export const de = {
  scene: {
    loading: 'Hintergrund wird geladen…',
    recovering: 'Bild wird wiederhergestellt…',
    unavailable: 'Hintergrund konnte nicht geladen werden',
    retryHint:
      'Ein neuer Versuch läuft. Falls das Laden nicht abgeschlossen wird, öffne die App erneut.',
  },
  bootstrap: {
    unsupportedBrowser: {
      title: 'Dieser Browser wird nicht unterstützt',
      description: 'Die Grafik der App ist mit deiner aktuellen Browserkonfiguration nicht verfügbar. Öffne Neiro Oracle in einem anderen Browser aus der Liste unten.',
      browsers: 'Unterstützte Browser',
      requirement: 'Verwende eine aktuelle Version mit verfügbarer WebGL-Grafik. Browser- oder Geräteeinstellungen können die Grafikunterstützung einschränken.',
      safari: 'Safari · iPhone, iPad und Mac',
    },
    loadingSpace: 'Dein Raum wird vorbereitet…',
    loadingOracle: 'Orakel wird geöffnet…',
    startupError: 'App konnte nicht gestartet werden',
    retry: 'Erneut versuchen',
    staleTelegram:
      'Deine Telegram-Sitzung ist abgelaufen. Schließe die Mini App und öffne sie erneut.',
    authTelegramError: 'Telegram-Anmeldung konnte nicht bestätigt werden',
    updateTelegramError:
      'Die Mini App konnte nicht aktualisiert werden. Schließe sie vollständig und öffne sie erneut.',
    missingTelegramData:
      'Telegram hat keine Startdaten übermittelt. Schließe die Mini App und öffne sie erneut.',
  },
  back: 'Zurück',
  close: 'Schließen',
  loading: 'Wird geladen…',
  routeReading: {
    loading: 'Deutung wird geöffnet…',
    error: 'Deutung nicht verfügbar',
    errorHint:
      'Sie wurde möglicherweise gelöscht oder gehört zu einem anderen Profil.',
    retry: 'Erneut versuchen',
  },
  save: 'Speichern',
  tomorrow: 'Morgen',
  collapse: 'Einklappen',
  app: {
    title: 'NEIRO ORACLE',
    subtitle: 'Orakelsystem v{{version}}',
    version: 'v{{version}}',
  },
  oracleGuide: {
    eyebrow: 'Neiro Oracle',
    title: 'So funktioniert das Orakel',
    introduction:
      'Zwei Wege, das I Ging für unterschiedliche Anliegen zu befragen.',
    accessibilityLabel: 'Anleitung zu Tageszeichen und Deutungen',
    open: 'So nutzt du das Orakel',
    close: 'Anleitung schließen',
    understood: 'Verstanden',
    daily: {
      title: 'Tageszeichen',
      body: 'Du brauchst keine Frage. Das Zeichen gibt dir ein Thema und praktische Orientierung für den Tag.',
    },
    reading: {
      title: 'Befragung',
      body: 'Formuliere eine konkrete Frage und behalte sie beim Münzwurf im Sinn. Die Deutung zeigt die aktuelle Situation, ihre Veränderungen und eine mögliche Richtung.',
    },
    journal: {
      title: 'Tagebuch',
      body: 'Tageszeichen und Deutungen werden in einem gemeinsamen Verlauf gespeichert. Nach einer Deutung kannst du eine Entscheidung festhalten.',
    },
    example: {
      title: 'Eine hilfreiche Frage',
      body: '„Was sollte ich vor dem Gespräch mit meinem Team bedenken?“',
    },
  },
  dailyDetails: {
    title: 'Details',
    loading: 'Zeichen wird geladen…',
    loadError:
      'Das Zeichen konnte in der gewählten Sprache nicht geladen werden.',
    retry: 'Erneut versuchen',
    fullText: 'Thema für heute',
    situationEssence: 'Frage zur Überprüfung',
    innerTension: 'Was zu beachten ist',
    action: 'Was du heute tun kannst',
    askAbout: 'Dazu eine Frage stellen',
    introduction:
      'Für das Tageszeichen brauchst du keine Frage. Es gibt dir ein Thema und praktische Orientierung für den Tag.',
  },
  classicalText: {
    title: 'KLASSISCHER TEXT',
    future: 'KLASSIK · KÜNFTIGES ZEICHEN',
    judgment: 'HEXAGRAMMSPRUCH',
    lines: 'LINIENSPRÜCHE',
    parallelLines: 'HEXAGRAMMLINIEN',
    line: 'Linie {{number}}',
    lineStatement: 'KLASSISCHER SPRUCH',
    sourceLabel: 'I Ging',
    rulingLine: 'HERRSCHENDE LINIE',
    specialLine: 'Besonderer Spruch',
  },
  home: {
    title: 'NEIRO ORACLE',
    subtitle: 'Orakelsystem v{{version}}',
    statusText: '> Alle Systeme betriebsbereit',
    daily: {
      title: 'Tageszeichen',
      caption: 'Ohne Frage · Thema und Orientierung für den Tag',
      actionTitle: 'Handlung für heute',
      askNow: 'Deutung beginnen',
      moreDetails: 'Mehr lesen',
      hideDetails: 'Details ausblenden',
      detailsTitle: 'Vollständige Beschreibung',
      lastResult: 'Letztes Ergebnis',
      noLastResult: 'Keine',
      emptyState: 'Noch keine Deutungen. Beginne eine Deutung →',
      empty: {
        subtitle: 'Tippe, um dein heutiges Zeichen zu erhalten',
        hint: 'Ritual mit einem Tippen',
        button: 'Zeichen erhalten',
      },
      loading: {
        searching: 'Hexagramm wird gesucht…',
        revealing: 'Sechs Linien werden enthüllt…',
      },
      pinnedToday: 'Für heute festgelegt',
      newSign: 'Neues Zeichen',
      resetReasons: {
        title: 'Grund für die Aktualisierung',
        sleep: 'Nach dem Schlaf aufgewacht',
        situationChanged: 'Die Situation hat sich verändert',
        other: 'Anderer Grund',
      },
      resetConfirm: {
        title: 'Zeichen aktualisieren?',
        message:
          'Das Zeichen für einen neuen Wachzyklus aktualisieren? Das aktuelle bleibt im Tagebuch.',
        confirm: 'Aktualisieren',
        cancel: 'Abbrechen',
      },
      nextUpdate: {
        prefix: 'Nächstes neues Zeichen —',
        afterSleep: 'nach dem nächsten Schlaf',
        tomorrow: 'morgen um 07:00',
        or: 'oder',
        available: 'jetzt verfügbar',
      },
      updated: 'Zeichen aktualisiert — neuer Wachzyklus',
      limitReached: 'Aktualisierungslimit für heute erreicht',
      disclaimer:
        'Zur Selbstreflexion und Unterhaltung. Keine medizinische oder finanzielle Beratung.',
    },
    question: {
      title: 'Hast du eine konkrete Frage?',
      subtitle:
        'Eine Deutung beleuchtet die Situation, ihre Veränderungen und eine mögliche Richtung',
      askNow: 'Deutung beginnen',
      hint: 'Ohne Thema. Zeigt das künftige Hexagramm sowie aktuelle und wandelnde Linien',
    },
    buttons: {
      iching: 'I-GING-ORAKEL',
      designSystem: 'DESIGNSYSTEM',
      simpleTest: 'EINFACHER TEST',
      hexagramTest: 'HEXAGRAMMTEST',
    },
  },
  iching: {
    title: 'I-GING-ORAKEL',
    subtitle: 'MOBIL v{{version}}',
    throwCoins: 'Münzen werfen',
    castingHexagram: 'Hexagramm wird gebildet…',
    generationError:
      'Das Zeichen konnte nicht gebildet werden. Prüfe deine Verbindung und wiederhole das Ritual.',
    retry: 'Erneut versuchen',
    castingWisdom: {
      '1': 'Eine Reise von tausend Li beginnt mit einem einzigen Schritt',
      '2': 'Fürchte nicht, langsam zu gehen; fürchte, stehen zu bleiben',
      '3': 'Das Weiche überwindet das Harte, das Ruhige das Rastlose',
      '4': 'Wandel ist die einzige Konstante unter dem Himmel',
      '5': 'Weise passen sich an wie Wasser an die Form eines Gefäßes',
      '6': 'Wenn das Zeichen entsteht, liegt die Antwort bereits in dir',
    },
    instruction:
      'Tippe, um dein Hexagramm zu bilden und Orientierung zu erhalten',
    linkActive: 'VERBINDUNG AKTIV',
    backButton: '← STARTSEITE',
    newDivination: 'NEUE DEUTUNG',
    sections: {
      hexagrams: 'HEXAGRAMME',
      interpretation: 'DEUTUNG',
      aiInsights: 'KI-EINBLICKE',
      general: 'ALLGEMEINE DEUTUNG',
      love: 'LIEBE UND BEZIEHUNGEN',
      work: 'ARBEIT UND KARRIERE',
      health: 'GESUNDHEIT UND WOHLBEFINDEN',
      travel: 'REISEN UND UNTERWEGSSEIN',
      changingLines: 'WANDELNDE LINIEN',
      futureHexagram: 'MÖGLICHER ZUSTAND',
      structuralFocus: 'WAS DIE SITUATION TRÄGT',
    },
    hexagram: {
      current: 'AKTUELL',
      future: 'MÖGLICH',
      present: 'AKTUELLE SITUATION',
      outcome: 'MÖGLICHE RICHTUNG',
      changing: 'WANDELNDE LINIEN',
      structural: 'WAS SIE ZUSAMMENHÄLT',
    },
    insights: {
      analyzing: 'Deutung wird erstellt…',
      transformation:
        '„{{current}}“ kann sich in Richtung „{{future}}“ wandeln. Wandelnde Linien: {{changes}}.',
      stable:
        'Keine Linien wandeln sich. Die Situation behält ihre aktuelle Richtung bei.',
    },
    changingLines: 'Wandelnde Linien',
    changingLinesDescription:
      'Diese Linien zeigen, wo sich die Situation verändern kann.',
    governingLineHint: 'Die Krone kennzeichnet eine herrschende Linie dieses Hexagramms.',
    allLinesTitle: 'Alle Linien ({{count}})',
    stableLineReadingsHint: 'Die Linien verändern sich nicht. Alle sechs Linien des Hexagramms werden angezeigt.',
    changingLinesTitle: 'Wandelnde Linien ({{count}})',
    structuralFocusTitle: 'Was die Situation zusammenhält',
    structuralFocusDescription:
      'Wenn sich keine Linien wandeln, zeigen diese Positionen, was die Situation derzeit zusammenhält.',
    lineNumber: 'Linie {{number}}',
    changingLinesNote:
      'Lies diese Linien aufmerksam: Sie zeigen, wo die Veränderung stattfindet.',
  },
  ask: {
    throw: {
      prepare: 'Formuliere deine Frage kurz und behalte sie im Sinn.',
      tips: {
        heart: 'Benenne, was dir wichtig ist',
        specific: 'Beschreibe die konkrete Situation',
        openEnded: 'Frage, was du bedenken solltest',
      },
      example:
        'Zum Beispiel: „Was sollte ich vor meiner Entscheidung bedenken?“',
      guide: {
        title: 'Vorbereitung',
        bestTime:
          'Frage, wenn du bereit bist, die Antwort in Ruhe zu betrachten',
        todayGood:
          'Lass dir vor einer wichtigen Entscheidung Zeit, die Fakten zu prüfen',
      },
    },
    result: {
      sections: {
        future: 'Mögliche Richtung',
        present: 'Was gerade geschieht',
        changes: 'Schwerpunkt der Deutung',
        structuralFocus: 'Was sie zusammenhält',
        advice: 'Wie du handeln kannst',
      },
      accessibility: {
        advice: 'Wie du handeln kannst. Rat',
      },
      content: {
        check: 'Frage zur Überprüfung',
        caution: 'Was zu beachten ist',
        primaryLine: 'Hauptschwerpunkt',
        secondaryLine: 'Ergänzendes Detail',
        relatingHint:
          'Das Bezugshexagramm bietet ein weiteres Thema zum Vergleich mit der Situation.',
        visibleStructure: 'Wie die Situation Gestalt annimmt',
        resultStructure: 'Wie sich die Situation entwickeln kann',
        hiddenDynamic: 'Was darunter vorgeht',
        hiddenCondition: 'Was das Ergebnis beeinflussen kann',
        corePattern: 'Worauf du achten kannst',
        coreTension: 'Wo die Schwierigkeit liegt',
        question: 'Deine Frage',
        questionContext: 'Im Zusammenhang mit der Frage',
        currentAction: 'Was du jetzt tun kannst',
        actionSource: 'Grundlage des Hinweises: {{ref}}',
        contextNeutral:
          'Dieser Hinweis zur Linie ist themenunabhängig und setzt keine Einzelheiten zu deiner Frage voraus.',
        secondaryHint:
          'Dies ist eine weitere Perspektive, keine zweite gleichzeitig auszuführende Anweisung. Der Hauptaspekt hat Vorrang.',
        methodContext:
          'Die App berücksichtigt das gewählte Thema und den zeitlichen Rahmen. Sie analysiert weder den Fragetext noch kennt sie die Gedanken anderer. Gleiche die Deutung mit den Tatsachen ab.',
        entryCondition: 'Wie du dich darauf zubewegen kannst',
        progressMarker: 'Woran du Fortschritt erkennst',
      },
      changeDepth: {
        stable:
          'Keine Linien wandeln sich. Der Abschnitt unten zeigt, was die Situation derzeit zusammenhält.',
        boundary:
          'Die Veränderung betrifft den Beginn oder das Ende der Situation.',
        internal:
          'Die Veränderung betrifft das Geschehen innerhalb der Situation.',
        systemic:
          'Die Veränderung reicht bis zur Grundlage der Situation und kann ihren Verlauf verändern.',
      },
      buttons: {
        decide: 'Entscheidung treffen',
      },
      more: 'Mehr lesen',
      skeleton: {
        loading: 'Wird geladen…',
      },
    },
    acceptDecision: {
      back: 'Zurück',
      title: 'Entscheidung treffen',
      subtitle:
        'Ergänze den Kontext, damit du später noch weißt, worum es ging.',
      reading: 'Grundlage der Entscheidung',
      questionLabel: 'Worum geht es bei dieser Entscheidung?',
      questionPlaceholder: 'Beschreibe kurz die Situation oder Frage…',
      questionHint: 'Optional. Dieser Kontext wird im Tagebuch gespeichert.',
      confirm: 'Annehmen und speichern',
      saving: 'Wird gespeichert…',
      cancel: 'Abbrechen',
      errorTitle: 'Entscheidung nicht gespeichert',
      errorMessage: 'Bitte versuche es erneut.',
    },
  },
  themes: {
    title: 'DESIGN',
    dark: 'DUNKEL',
    light: 'HELL',
    autumn: 'HERBST',
    active: 'AKTIV',
    dark_description: 'Dunkle Flächen mit dezenten Akzenten',
    light_description: 'Klares, modernes helles Design',
    autumn_description: 'Warme, von Herbstfarben inspirierte Erdtöne',
  },
  ui: {
    screenTitle: 'SEITENTITEL',
    info: 'INFO',
    language: 'SPRACHE',
    interfaceSettings: 'Sprache und Design',
    loadingStates: {
      loading: 'Wird geladen…',
      processing: 'WIRD VERARBEITET…',
      connecting: 'VERBINDUNG WIRD HERGESTELLT…',
      deleting: 'WIRD GELÖSCHT…',
    },
  },
  tabs: {
    home: 'Startseite',
    journal: 'Tagebuch',
    hexagrams: 'Hexagramme',
    profile: 'Profil',
  },
  desktop: {
    oracle: 'Orakel',
    brandSubtitle: 'I Ging für Entscheidungen',
    appearance: 'Darstellung',
    theme: 'Oberflächendesign',
  },
  hexagrams: {
    title: 'Hexagramme',
    subtitle: 'Alle 64 Zeichen des I Ging — wähle die passende Reihenfolge',
    hint: 'Wähle ein Zeichen, um seine Deutung zu öffnen',
    loading: 'Hexagrammkatalog wird geladen…',
    error: 'Der Hexagrammkatalog konnte nicht geladen werden.',
    retry: 'Erneut versuchen',
    order: {
      title: 'Reihenfolge',
      kingWen: '1–64',
      'king-wen': '1–64',
      fuXi: 'Fu Xi',
      'fu-xi': 'Fu Xi',
      mawangdui: 'Mawangdui',
    },
    matrix: {
      accessibilityLabel: 'Matrix der 64 Hexagramme. Reihenfolge: {{order}}',
      cellAccessibilityLabel: 'Hexagramm {{number}}. {{name}}',
    },
    modal: {
      accessibilityLabel: 'Hexagramm {{number}}. {{name}}',
      number: 'Hexagramm {{number}}',
      close: 'Hexagrammdetails schließen',
      modernTitle: 'Moderne Deutung',
      pattern: 'Was geschieht',
      tension: 'Wo die Schwierigkeit liegt',
      structureTitle: 'Struktur der Situation',
      visibleStructure: 'Wie die Situation Gestalt annimmt',
      hiddenDynamic: 'Was darunter vorgeht',
      rolesTitle: 'Rolle des Hexagramms',
      initialRole: 'Wenn das Zeichen die aktuelle Situation beschreibt',
      resultingRole: 'Wenn das Zeichen einen möglichen Zustand darstellt',
      roleSummary: 'Bedeutung der Rolle',
      action: 'Wie du handeln kannst',
      entry: 'Wie du diesen Zustand erreichen kannst',
      marker: 'Anzeichen für Fortschritt',
      linesTitle: 'Sechs Linien',
      spheresTitle: 'Handlung zu deinem Thema',
      spheres: {
        general: 'Situation oder Wahl',
        newjob: 'Neue Stelle',
        work: 'Aktuelle Arbeit',
        love: 'Beziehungen',
        project: 'Projekt',
      },
      dailyTitle: 'Orientierung für den Tag',
      dailyFocus: 'Tagesthema',
      dailyAction: 'Praktischer Schritt',
    },
  },
  journal: {
    actionsFor: 'Aktionen für „{{title}}“',
    entryActions: 'Eintragsaktionen',
    deleteConfirm: 'Eintrag löschen?',
    deleteEntry: 'Löschen',
    cancelDelete: 'Abbrechen',
    deleting: 'Wird gelöscht…',
    deleteDailyHint:
      'Dieses Zeichen wird entfernt. Ist es das aktuelle, tritt das neueste verbleibende Zeichen dieses Datums an seine Stelle. Das erste Tageszeichen bleibt erhalten.',
    deleteReadingHint:
      'Diese Deutung und die dazu festgehaltene Entscheidung werden dauerhaft gelöscht.',
    deleteError:
      'Das Löschen konnte nicht bestätigt werden. Bitte versuche es erneut.',
    selectEntry: 'Wähle einen Tagebucheintrag',
    entryNotFound:
      'Eintrag nicht gefunden. Wähle einen anderen Eintrag aus der Liste.',
    title: 'Tagebuch',
    filters: {
      all: 'Alle',
      decisions: 'Deutungen',
      daily: 'Tageszeichen',
    },
    searchPlaceholder: 'Nach Titel und Notiz suchen',
    empty: 'Hier erscheinen deine Deutungen',
    emptyHint: 'Die erste Deutung erscheint nach „Deutung beginnen“',
    emptyAll: 'Hier erscheinen deine Tagebucheinträge',
    emptyAllHint:
      'Deutungen und Tageszeichen bleiben in einem gemeinsamen Verlauf',
    emptyDecisions: 'Hier erscheinen deine Deutungen',
    emptyDecisionsHint: 'Die erste Deutung erscheint nach „Deutung beginnen“',
    emptyDaily: 'Hier erscheinen deine Tageszeichen',
    emptyDailyHint: 'Erhalte dein erstes Zeichen auf der Orakelseite',
    error: 'Tagebuch konnte nicht geladen werden',
    errorHint: 'Prüfe deine Verbindung und versuche es erneut',
    retry: 'Erneut versuchen',
    labels: {
      decision: 'Befragung',
      accepted: 'Deutung · Entscheidung festgehalten',
      daily: 'Tageszeichen',
      question: 'Frage',
    },
  },
  profile: {
    title: 'Profil',
    account: {
      title: 'Konto',
      loginTelegram: 'Mit Telegram fortfahren',
      loginHint:
        'Der Kontoverlauf ist auf allen Geräten verfügbar; lokale Einträge bleiben auf diesem Gerät',
      loginUnavailable:
        'Die Anmeldung wird nach der Einrichtung von Telegram Login verfügbar',
      synchronized: 'Kontodaten werden geräteübergreifend synchronisiert',
      logout: 'Abmelden',
      loginErrorTitle: 'Anmeldung fehlgeschlagen',
      loginError:
        'Telegram hat die Anmeldung nicht bestätigt. Bitte versuche es erneut.',
      logoutErrorTitle: 'Abmeldung fehlgeschlagen',
      logoutError: 'Prüfe deine Verbindung und versuche es erneut.',
    },
    subscription: {
      title: 'Abonnement',
      active: 'Aktiv',
      expired: 'Abgelaufen',
      free: 'Kostenloser Modus',
      activeUntil: 'Aktiv bis {{date}}',
      manage: 'Abonnement verwalten',
      connect: 'Neiro+ erhalten',
      restore: 'Käufe wiederherstellen',
      hint: 'Zugang zu ausführlichen Deutungen, Vergleichen und persönlichen Ratschlägen.',
      restored: 'Käufe wiederhergestellt',
      restoreError: 'Käufe konnten nicht wiederhergestellt werden',
      purchaseError: 'Das App-Store-Abonnement konnte nicht gestartet werden',
      loading: 'Status wird geprüft…',
      benefits: {
        privateGroup: 'Zugang zur privaten Neiro+-Gruppe',
        earlyUpdates: 'Frühzeitiger Zugang zu Oracle-Updates',
      },
      whatsIncluded: 'Was ist enthalten?',
    },
    notifications: {
      title: 'Mitteilungen',
      morning: 'Morgen',
      morningHint: 'Wähle, wann und wo du dein Morgenzeichen erhalten möchtest',
      morningEnabledDestinationsHint:
        'Das Tageszeichen wird um {{time}} zurückgesetzt · {{destinations}}',
      morningDisabledDestinationsHint:
        'Das Tageszeichen wird um {{time}} zurückgesetzt; Mitteilungen sind aus',
      destinations: {
        title: 'Erinnerungen senden an',
        local: 'Dieser Mac',
        telegram: 'Telegram',
      },
      timeHint: 'Beginn des Morgens',
      invalidTime: 'Gib die Zeit als HH:MM ein, zum Beispiel 09:00',
      timePicker: {
        title: 'Wann beginnt dein Morgen?',
        descriptionEnabled:
          'Zu dieser Zeit wird dein Tageszeichen zurückgesetzt und der Telegram-Bot sendet eine Erinnerung.',
        descriptionEnabledLocal:
          'Zu dieser Zeit wird dein Tageszeichen zurückgesetzt und macOS zeigt eine Erinnerung.',
        descriptionEnabledMultiple:
          'Zu dieser Zeit wird dein Tageszeichen zurückgesetzt und die ausgewählten Kanäle senden eine Erinnerung.',
        descriptionDisabled:
          'Zu dieser Zeit wird dein Tageszeichen zurückgesetzt. Mitteilungen bleiben ausgeschaltet.',
        descriptionChannelUnavailable:
          'Zu dieser Zeit wird dein Tageszeichen zurückgesetzt. Erinnerungen beginnen, sobald der Telegram-Kanal verfügbar ist.',
        descriptionChannelUnavailableLocal:
          'Zu dieser Zeit wird dein Tageszeichen zurückgesetzt. macOS fragt nach der Erlaubnis für Mitteilungen.',
        quickChoice: 'Schnellauswahl',
        setPreset: '{{time}} einstellen',
        hours: 'Stunden',
        minutes: 'Minuten',
        decreaseHours: 'Stunden um eins verringern',
        increaseHours: 'Stunden um eins erhöhen',
        decreaseMinutes: 'Minuten um fünf verringern',
        increaseMinutes: 'Minuten um fünf erhöhen',
        directEntryHint:
          'Du kannst einen genauen Wert über die Tastatur eingeben',
        invalidHours: 'Gib eine Stunde von 00 bis 23 ein',
        invalidMinutes: 'Gib Minuten von 00 bis 59 ein',
      },
      loadError: 'Morgeneinstellung konnte nicht geladen werden',
      saveError: 'Morgeneinstellung konnte nicht gespeichert werden',
      retry: 'Erneut versuchen',
      testSent: 'Testnachricht an Telegram gesendet',
      testSentLocal: 'Eine Testmitteilung erscheint in zwei Sekunden',
      testSentMultiple:
        'Testerinnerungen wurden an die ausgewählten Kanäle gesendet',
      testError: 'Testnachricht konnte nicht gesendet werden',
      channel: {
        active: 'Telegram-Bot ist bereit',
        unverified:
          'Öffne den Telegram-Bot und bestätige den Empfang von Nachrichten',
        blocked:
          'Der Telegram-Bot ist blockiert. Hebe die Blockierung in Telegram auf',
        disconnected: 'Die Verbindung zum Telegram-Bot wurde unterbrochen',
        not_connected: 'Telegram-Bot ist noch nicht verbunden',
      },
      localChannel: {
        active: 'macOS-Mitteilungen sind erlaubt',
        unverified: 'Die Erlaubnis für macOS-Mitteilungen ist nicht bestätigt',
        blocked: 'Erlaube Mitteilungen in den macOS-Einstellungen',
        disconnected: 'macOS-Mitteilungen sind derzeit nicht verfügbar',
        not_connected:
          'Die Erlaubnis wird beim Aktivieren der Erinnerungen angefragt',
      },
      testNotification: 'Test senden',
    },
    preferences: {
      title: 'Einstellungen',
      haptics: 'Haptisches Feedback',
      hapticsHint: 'Leichte Vibration beim Werfen und Speichern',
    },
    classicalText: {
      title: 'Hexagrammtexte',
      hint: 'Wähle die moderne Deutung, den überlieferten Zhouyi-Text oder beide Ebenen',
      modern: 'Modern',
      classical: 'Klassisch',
      parallel: 'Beide',
    },
    language: {
      interface: 'Sprache der Oberfläche',
      russian: 'Русский',
      english: 'English',
    },
    data: {
      title: 'Daten und Privatsphäre',
      exportJournal: 'Tagebuch exportieren',
      exportPeriod: 'Zeitraum',
      allData: 'Alle Daten',
      last30Days: 'Letzte 30 Tage',
      export: 'Exportieren',
      exportError: 'Export fehlgeschlagen',
      deleteAccount: 'Persönliche Daten und Konto löschen',
      deleteAccountHint:
        'Persönliche Daten, Verlauf, Einstellungen und Konto werden aus der App gelöscht',
      deleteAccountConfirm:
        'Profildaten, Tagebuch, Einstellungen und Konto werden gelöscht. Die nächste Anmeldung erstellt ein neues Konto. Es bleiben nur technische Belege ohne Inhalte: Telegram-Belege für 7 Tage zum Schutz vor erneuter Verarbeitung und die Löschbestätigung für 30 Tage. Danach werden diese Belege automatisch entfernt.',
      deleteAccountError:
        'Persönliche Daten und Konto konnten nicht gelöscht werden. Prüfe die Verbindung und versuche es erneut.',
      deleteLocalData: 'Alle persönlichen Daten löschen',
      deleteLocalDataHint:
        'Der von dieser App auf dem Gerät gespeicherte Verlauf und die Einstellungen werden gelöscht',
      deleteLocalDataConfirm:
        'Alle von dieser App auf dem Gerät gespeicherten Daten werden gelöscht. Danach öffnet sich ein leerer Startbildschirm.',
      deleteLocalDataError:
        'Die App-Daten konnten nicht gelöscht werden. Bitte versuche es erneut.',
      cancel: 'Abbrechen',
      deleteAccountAction: 'Konto löschen',
      deleteLocalDataAction: 'Daten löschen',
      privacy: 'Datenschutzrichtlinie',
      terms: 'Nutzungsbedingungen',
      disclaimer:
        'Zur Selbstreflexion und Unterhaltung. Keine medizinische oder finanzielle Beratung.',
    },
    support: {
      title: 'Support',
      guide: 'So funktioniert das Orakel',
      guideHint: 'Tageszeichen, Deutungen und Tagebuch',
      contact: 'Support kontaktieren',
      rate: 'App bewerten',
      rateNow: 'Jetzt bewerten',
      version: 'Version {{version}}',
      devTools: 'Entwicklerwerkzeuge',
      devToolsDesc: 'Fernkonfiguration, Push-Tests, Testdaten (Platzhalter)',
    },
    about: {
      title: 'Über die App',
      version: 'Version {{version}}',
      platform: '{{platform}}',
    },
    resolveNow: 'Jetzt entscheiden',
  },
};
